import {useEffect} from 'react'

const defaultVersion = '2.0.0'
const defaultSri = 'sha384-yUCj6Q8h0Q6zFc35iT7v7pFoqlgpBD/xVr5SQxOgAnu2Cq286mf7IAyrFBJ8OsIa'

export function LatestVersion() {
	useEffect(() => {
		async function updateDocs() {
			try {
				const res = await fetch('https://registry.npmjs.org/@primer-io/checkout-web/latest')
				const data = await res.json()
				const latestVersion = data.version

				document.querySelectorAll('code, .token').forEach(el => {
					el.textContent = el.textContent?.replace(defaultVersion, latestVersion)
				})

				const scriptUrl = `https://sdk.primer.io/web/v${latestVersion}/Primer.min.js`
				let sri = defaultSri

				// Compute SRI hash for the script
				try {
					const scriptResponse = await fetch(scriptUrl)
					const scriptBuffer = await scriptResponse.arrayBuffer()

					const hashBuffer = await crypto.subtle.digest('SHA-384', scriptBuffer)
					const hashArray = Array.from(new Uint8Array(hashBuffer))
					const base64Hash = btoa(String.fromCharCode(...hashArray))

					sri = `sha384-${base64Hash}`
				} catch (err) {
					console.warn('Failed to generate dynamic SRI hash. Using fallback.', err)
				}

				// Replace v2.0.0 SRI with the latest version
				document.querySelectorAll('code, .token').forEach(el => {
					el.textContent = el.textContent?.replace(defaultSri, sri)
				})
			} catch (err) {
				console.error('Failed to update docs:', err)
			}
		}

		updateDocs()
	}, [])

	return null
}
